import React from 'react'
import style from './Image.module.css'

function Image({ src, alt }) {
  return (
    <img src={src} alt={alt} className={`${style.image}`} />
  )
}

export default Image